import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FILESAVER from 'file-saver';
import { GlobalService } from 'src/app/_services/global.service';
import { UploadService } from 'src/app/user-management/_services/upload.service';
import { Router } from '@angular/router';
import { ErrorMsgService } from '../error-msg/error-msg.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/dashboard/_services/data.service';

declare var $: any;

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit , AfterViewInit , OnDestroy{
  file;
  fileName: string;
  user_role: string;
  fileTitles = [];
  mapping: any = {};
  fileRows;
  fileErrors = [];
  successMessage;
  errorMessage;
  showCards = false;
  disableUploadBtn = true;
  systemFieldNames = [];
  loading: boolean = false;
  matSelect = [];
  currLang;
  getErrors$ = new Subscription;
  showBrowseModal = false;
  normalizedFileData: any = null; // Global variable to hold the normalized data (normalized means without spaces and lowercase)
  normalizedFile: File | null = null; // New variable to store the normalized file

  constructor(private uploadService: UploadService,
    private errorMsgService: ErrorMsgService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private router: Router,
    private dataService: DataService,
    ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
      
    });
  }

  ngOnInit(): void {
       // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
       $('.modal').modal('hide');
       $('body').removeClass('modal-open');
       $('.modal-backdrop').remove();  
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.fileName = null;
    this.showCards = false;
    this.user_role = window.location.pathname.split('/')[2] === 'upload' ? 'students' : 'staff';
    this.mapping = {};
    this.globalService.stopLoading();

    $(document).on('hidden.bs.modal', '#resultModal', () => {
      this.fileRows = 0;
      this.getErrors$.unsubscribe();
    })

    // this.uploadService.getFieldData().subscribe((res: any) => {
    //   if (res !== null) {
    //     this.globalService.stopLoading();
    //     this.fileErrors = this.fileErrors.filter(fileError => fileError.count !== res.count);
    //     if (this.fileErrors.length === 0) {
    //       this.showCards = false;
    //     }
    //   }
    // })

    this.uploadService.getfieldCorrectionProgress().subscribe(res=>{
      if(res == 100){
        this.showCards = false;
      }
    })

    this.globalService.getLoading().subscribe(res => {
      this.loading = res;
    })

    switch (this.user_role) {
      case 'students':
        this.mapping = {}
        this.translate.onLangChange.subscribe(param => {
          // this.studentFields();
          
        
        });
        this.translate.get('init').subscribe(param => {
          this.studentFields();
         
        })
      
        break;
      case 'staff':
        this.mapping = {}
        this.translate.onLangChange.subscribe(param => {
          this.staffFields();
         
        
        })
        this.translate.get('init').subscribe(param => {
          this.staffFields();
        })
        break;
    }
    $("#uploadModal").modal("show");
  }

  ngAfterViewInit() {
   let x = this.globalService.getUploadErrorsUrl().subscribe(url=>{
      if(!!url){
        this.uploadService.getUploadErrors(url).subscribe(res=>{
          this.globalService.setUploadErrorsUrl(null)
          if (res.errors) {
          let count = 0;
          this.fileErrors = res.errors.errors;
          this.fileErrors.map(fileError => {
            fileError.count = count;
            count++;
          })
          
        }
        if (this.fileErrors) {
          this.fileRows = this.fileErrors.length;
          if(this.fileRows < 0){
            this.fileRows=0;
          }
        }
        // this.disableUploadBtn = true;
        // this.mapping = {};
        // this.matSelect.map(oneSelect => {
        //   oneSelect.writeValue(null)
        // })
        // this.loading = false;
        $("#resultModal").modal("show");
        })
      }
    })
    this.getErrors$.add(x);
  }
  

  onBrowseClick() {
    this.showBrowseModal = true;
  }

  confirmUploading(){
    $("#fileUpload").click();
  }

  studentFields() {
    this.systemFieldNames = [
      { name:'user-management.upload.upload-fields.student-name', value: 'name', validation_1:'user-management.upload.upload-fields.validations.student-name',required:true ,showValidationHeader:false},
      { name:'user-management.upload.upload-fields.student-national-id', value: 'national_id',validation_1:'user-management.upload.upload-fields.validations.student-national-id',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.student-gender', value: 'gender',validation_1:'user-management.upload.upload-fields.validations.student-gender-1' ,validation_2:'user-management.upload.upload-fields.validations.student-gender-2' ,validation_3:'user-management.upload.upload-fields.validations.student-gender-3',required:false ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.grade', value: 'grade_name', validation_1:'user-management.upload.upload-fields.validations.grade-1' , validation_2:'user-management.upload.upload-fields.validations.grade-2',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.class', value: 'class_name',validation_1:'user-management.upload.upload-fields.validations.class-1' ,validation_2:'user-management.upload.upload-fields.validations.class-2',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.create-grade-and-class', value: 'create_grade_and_class',validation_1:'user-management.upload.upload-fields.validations.create-grade-and-class-1' ,validation_2:'user-management.upload.upload-fields.validations.create-grade-and-class-2',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.parent-name', value: 'parent_name',validation_1:'user-management.upload.upload-fields.validations.parent-name' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.parent-gender', value: 'parent_gender',validation_1:'user-management.upload.upload-fields.validations.parent-gender-1' ,validation_2:'user-management.upload.upload-fields.validations.parent-gender-2' ,validation_3:'user-management.upload.upload-fields.validations.parent-gender-3',required:false ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.parent-national-id', value: 'parent_national_id',validation_1:'user-management.upload.upload-fields.validations.parent-national-id',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.code', value: 'parent_country_code',validation_1:'user-management.upload.upload-fields.validations.code-1' ,validation_2:'user-management.upload.upload-fields.validations.code-2',required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.phone', value: 'parent_phone',validation_1:'user-management.upload.upload-fields.validations.phone' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.parent-email', value: 'parent_email',validation_1:'user-management.upload.upload-fields.validations.parent-email-1' ,validation_2:'user-management.upload.upload-fields.validations.parent-email-2' ,validation_3:'user-management.upload.upload-fields.validations.parent-email-3',required:false ,showValidationHeader:true}
    ]
  }
  staffFields() {
    this.systemFieldNames = [
      { name:'user-management.upload.upload-fields.staff-name', value: 'name',validation_1:'user-management.upload.upload-fields.validations.staff-name' ,required:true ,showValidationHeader:false},
      { name:'user-management.upload.upload-fields.role-type', value: 'role_type',validation_1:'user-management.upload.upload-fields.validations.role-type' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.staff-national-id', value: 'national_id',validation_1:'user-management.upload.upload-fields.validations.staff-national-id' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.staff-email', value: 'email',validation_1:'user-management.upload.upload-fields.validations.staff-email-1' ,validation_2:'user-management.upload.upload-fields.validations.staff-email-2' ,validation_3:'user-management.upload.upload-fields.validations.staff-email-3' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.staff-gender', value: 'gender',validation_1:'user-management.upload.upload-fields.validations.staff-gender-1' ,validation_2:'user-management.upload.upload-fields.validations.staff-gender-2' ,validation_3:'user-management.upload.upload-fields.validations.staff-gender-3',required:false ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.staff-phone', value: 'phone',validation_1:'user-management.upload.upload-fields.validations.staff-phone' ,required:true ,showValidationHeader:true},
      { name:'user-management.upload.upload-fields.staff-country-code', value: 'country_code',validation_1:'user-management.upload.upload-fields.validations.staff-country-code-1' ,validation_2:'user-management.upload.upload-fields.validations.staff-country-code-2',required:true ,showValidationHeader:true}
    ]
  }
  onSelectChange(input_name, event) {
    this.mapping[input_name] = event.value;
    this.matSelect.push(event.source)

    if (this.user_role === 'staff') {
      this.disableUploadBtn = Object.keys(this.mapping).length > 6 ? false : true;
    }
    else if (this.user_role === 'students') {
      this.disableUploadBtn = Object.keys(this.mapping).length > 11 ? false : true;
    }

  }

  // onFileChange(ev) {
  //   let file = ev.target.files[0];
  //   if (file) {
  //     this.showBrowseModal = false;
  //     // To validate the uploaded file format to only allow xl sheets
  //     let val = file.name.toLowerCase();      
  //     let regex = new RegExp("(.*?)\.(xlsx|xlsm|xlsb|xltx|xltm|xls|xlt|xml|xla|xlw|xlr)$");
  //     if (!(regex.test(val))) {
  //       this.fileName = null;
  //       this.fileTitles = [];
  //       setTimeout(() => {
  //         alert(this.translate.instant('user-management.upload.unsupported-format'));
  //       }, 50);
  //     }
  //     else {
  //       let workBook = null;
  //       let jsonData = null;
  //       const reader = new FileReader();
  //       this.file = ev.target.files[0];
  //       reader.onload = (event) => {
  //         const data = reader.result;
  //         workBook = XLSX.read(data, { type: 'binary' });
  //         jsonData = workBook.SheetNames.reduce((initial, name) => {
  //           const sheet = workBook.Sheets[name];
  //         //  raw and defVal to allow columns with empty values to appear in the json file 
  //           initial[name] = XLSX.utils.sheet_to_json(sheet, {raw: true, defval:null});
  //           return initial;
  //         }, {});
  //         this.fileRows = 0;
  //         this.fileRows = Object.values(Object.values(jsonData)[0]).length;
  //         this.fileName = Object.keys(jsonData)[0];
  //         this.fileTitles = Object.keys(Object.values(Object.values(jsonData)[0])[0]);              
  //         this.fileTitles.forEach(element => {
  //         this.mapping[element] = element;
  //         });
          
  //         if (this.user_role === 'staff') {
  //           this.disableUploadBtn = Object.keys(this.mapping).length > 6 ? false : true;
  //         }
  //         else if (this.user_role === 'students') {
  //           this.disableUploadBtn = Object.keys(this.mapping).length > 11 ? false : true;
  //         }
  //       }
  //       reader.readAsBinaryString(this.file);
  //     }
  //   }
  // }

  onFileChange(ev) {
    this.loading = true; 
    const file = ev.target.files[0];
    if (file) {
      this.showBrowseModal = false;
  
      // Validate the uploaded file format
      const val = file.name.toLowerCase();
      const regex = new RegExp("(.*?)\\.(xlsx|xlsm|xlsb|xltx|xltm|xls|xlt|xml|xla|xlw|xlr)$");
      if (!regex.test(val)) {
        this.fileName = null;
        this.fileTitles = [];
        setTimeout(() => {
          alert(this.translate.instant('user-management.upload.unsupported-format'));
        }, 50);
        this.loading = false;
        return;
      }
  
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = reader.result;
        const workBook = XLSX.read(data, { type: 'binary' });
        const jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet, { raw: true, defval: null });
          return initial;
        }, {});
  
        // Assuming the first sheet is the one you want to normalize
        const originalTitles = Object.keys(Object.values(jsonData)[0][0]);
        const normalizedTitles = originalTitles.map(title => title.trim().replace(/\s+/g, '').toLowerCase());
  
        // Normalize the data
        const normalizedData = jsonData[Object.keys(jsonData)[0]].map(row => {
          return normalizedTitles.reduce((acc, title, index) => {
            const originalTitle = originalTitles[index]; // Get the original title
            acc[title] = row[originalTitle]; // Assign the value from the original title to the normalized title
            return acc;
          }, {});
        });
  
        // Store the normalized data in the global variable
        this.normalizedFileData = { [file.name]: normalizedData };
  
        // Create a new workbook for the modified data
        const newWorkbook = XLSX.utils.book_new();
        const newWorksheet = XLSX.utils.json_to_sheet(normalizedData, { header: normalizedTitles });
        XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Sheet1');
  
        // Create a new blob and then a file from the workbook
        const newFileData = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'binary' });
        const blob = new Blob([this.s2ab(newFileData)], { type: 'application/octet-stream' });
        this.normalizedFile = new File([blob], file.name.replace(/\.(xlsx|xlsm|xlsb|xltx|xltm|xls|xlt|xml|xla|xlw|xlr)$/, '-normalized.xlsx'), { type: blob.type });
  
        this.fileRows = normalizedData.length; // Update fileRows
        this.fileName = this.normalizedFile.name; // Update fileName to reflect the new file
  
        // Set the normalized titles to fileTitles for later use
        this.fileTitles = normalizedTitles; 
        
        // Update mapping if needed
        this.fileTitles.forEach(element => {
          this.mapping[element] = element;
        });
  
        // Update button state based on mapping length
        this.disableUploadBtn = (this.user_role === 'staff' && Object.keys(this.mapping).length <= 6) ||
                                (this.user_role === 'students' && Object.keys(this.mapping).length <= 11);
        this.loading = false; 
      };
  
      reader.readAsBinaryString(file); // Read the original file
    }
    else{
      this.loading = false;
    }
  }

    // Helper function to convert string to array buffer
s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
}

  exportToExcelFile() {
    let workBook = XLSX.utils.book_new();
    workBook.SheetNames.push('test sheet');
    let valuesToBeExported = [];
    this.fileErrors.map(fileError => {
      valuesToBeExported.push(fileError.values)
    })
    let ws_Data = valuesToBeExported;
    let ws = XLSX.utils.json_to_sheet(ws_Data);
    workBook.Sheets['test sheet'] = ws;
    let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

    function s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
      return buf;
    }

    $("#button-a").click(function () {
      FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
    });
  }

  upload() {
    $("#uploadModal").modal("hide");
  }

  showCardsFunc() {
    this.showCards = true;
    $("#resultModal").modal("hide");
  }

  // Validate that the field name match a value in the fileTitles 
  isFieldValid(field: any): boolean {
    if(this.fileTitles.length > 0){
      return this.fileTitles.includes(field.value);
    }
    else {
      // return true so the error doesn't appear on initialize when the fileTitles is empty
      return true
    }
  }

    // Check if all fields are valid
    isFormValid(): boolean {
      // Ensure that every required field is valid
      return this.systemFieldNames.every(field => {
        // Check only required fields and validate them against fileTitles
        return  this.isFieldValid(field);
      });
    }

  // uploadFile() {
  //   // this.loading = true;
  //   let formData = new FormData;
  //   let response: any;
  //   if (this.user_role == "staff") {
  //     formData.append('users_file', this.file);
  //   } else {
  //     formData.append('students_file', this.file);
  //   }
  //   //fill form data with mapping attributes
  //   for (const key in this.mapping) {
  //     formData.append(`mapping[${key}]`, this.mapping[key]);
  //   }
  
  //   //call api request based on user role type
  //   if (this.user_role == "staff") {
  //     response = this.uploadService.uploadStaff(formData)
  //   } else {
  //     response = this.uploadService.uploadStudents(formData)
  //   }
  //   //api request callback response
  //   this.globalService.setUploadSheet('preparing');
  //   response.subscribe(
  //     // res => {
  //     //   if (res.errors) {
  //     //     let count = 0;
  //     //     this.fileErrors = res.errors;
  //     //     this.fileErrors.map(fileError => {
  //     //       fileError.count = count;
  //     //       count++;
  //     //     })
          
  //     //   }
  //     //   if (this.fileErrors) {
  //     //     this.fileRows = this.fileRows - this.fileErrors.length;
  //     //     if(this.fileRows < 0){
  //     //       this.fileRows=0;
  //     //     }
  //     //   }
  //     //   // this.disableUploadBtn = true;
  //     //   // this.mapping = {};
  //     //   // this.matSelect.map(oneSelect => {
  //     //   //   oneSelect.writeValue(null)
  //     //   // })
  //     //   this.loading = false;
  //     //   $("#resultModal").modal("show");
  //     //   // this.fileRows = 0;
  //     // },
  //     (error) => {
  //       // this.loading = false;
  //       // error.status !== 500 ?
  //       //   this.errorMsgService.setMessage(error.message) :
  //       //   this.currLang === 'en' ?
  //       //     this.errorMsgService.setMessage('Matching data failed, there are missing data') :
  //       //     this.errorMsgService.setMessage('خطأ في رفع البيانات ، هنالك بيانات مفقودة')
  //     }
  //   )
  // }

  uploadFile() {
    let formData = new FormData();
    let response: any;
  
    // Use the normalized file for sending to the backend
    if (this.user_role === "staff") {
      formData.append('users_file', this.normalizedFile);
    } else {
      formData.append('students_file', this.normalizedFile);
    }
  
    // Append normalized data to the FormData
    for (const key in this.mapping) {
      formData.append(`mapping[${key}]`, this.mapping[key]);
    }
  
    // Call API request based on user role type
    if (this.user_role === "staff") {
      response = this.uploadService.uploadStaff(formData);
    } else {
      response = this.uploadService.uploadStudents(formData);
    }
  
    // Handle API response
    this.globalService.setUploadSheet('preparing');
    response.subscribe(
      (res) => {
      },
      (error) => {
      }
    );
  }

  openConfirmModal() {
    $("#confirmModal").modal("show");
  }

  closeConfirmModal() {
    $("#confirmModal").modal("hide");
    this.showCards = false;
  }

  hideUpload() {
    this.loading = true;
    this.dataService.getUsers$().subscribe(res=>{
      this.dataService.setUsers$(res);
      this.uploadService.setUploadSectionState(false);
      this.loading = false;
    })
  }

  ngOnDestroy() {
    this.getErrors$.unsubscribe();
  }

}